import type { Locale } from "./Locale.js";

// when adding tenants, make sure to protect their DNS records in the security stack
export enum TenantId {
	cz = "cz",
	eu = "eu",
	pl = "pl",
	sk = "sk",
}

export type TenantizedString = Record<TenantId, string>;

export interface Tenant<Id = TenantId> {
	readonly id: Id;
	readonly domain: string;
	readonly locale: Locale;
}
